import React from 'react';
/**
 * loader component
 */
const Loader = () => {
    return (
        <div className="loader">
            <svg viewBox="0 0 100 100" width="75">
                <path
                    fill="#F76149"
                    d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                >
                    <animate
                        attributeName="fill"
                        values="#F76149;#2f25d2;#e42326;#F76149"
                        dur="8s"
                        repeatCount="indefinite"
                    />
                </path>
            </svg>
        </div>
    );
};

export default Loader;
